<div [innerText]="topic?.title"
  class="td-wb-help-article-index-header">
</div>
<ul class="td-wb-help-article-index-container">
  @for (article of topic?.items; track article) {
    <li class="td-wb-help-article-index-item">
      <a target="_self"
        class="td-wb-help-article-index-item-link"
        [attr.href]="'#/page/help/' + article.id"
        [attr.id]="article.id + '__link'"
        (click)="scrollToArticle(article.id); $event.preventDefault();">
        <span [innerText]="article.text"></span>
      </a>
    </li>
  }
</ul>

